module.exports = __webpack_public_path__ + "static/media/customers.f656adb0.svg";